import { defineMessages } from 'react-intl'

export default defineMessages({
  // Global
  servicesHeader: {
    id: 'app.services.header',
    defaultMessage: 'Road Services',
  },
  // List
  servicesListGasStations: {
    id: 'app.services.list.gasStations',
    defaultMessage: 'Gas Stations',
  },
  servicesListLocksmith: {
    id: 'app.services.list.locksmith',
    defaultMessage: 'Locksmith',
  },
  servicesListTowTruckServices: {
    id: 'app.services.list.towTruckServices',
    defaultMessage: 'Tow Truck Services',
  },
  servicesListPolice: {
    id: 'app.services.list.police',
    defaultMessage: 'Police',
  },
})
